import React, { useEffect, useState, Fragment } from 'react';
import { Row, Col, Card, Empty, message } from 'antd';
import HeadingChip from 'Molecules/HeadingChip';
import { useDispatch, useSelector } from 'react-redux';
import { getSalesHourly } from '../ducks/actions'
import { exportSalesReport } from '../ducks/services'
import Search from './components/Search';
import dayjs from 'dayjs';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { comma } from 'Features/utility';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.reporting.salesHourly);
  const meta = useSelector((state) => state.reporting.salesHourlyOption);
  const [searchVal, setSearchVal] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const i18n = useTranslate();
        const { t } = i18n;

  const btnList = [
    {
      text: t("General.export_report"),
      classes: 'green-btn',
      action: () => exportReport(),
    }
  ];

  useEffect(() => {
    dispatch(getSalesHourly(searchVal, props.setLoading, "1"));
    dispatch(getListQueryItems('setupListQuery', null));
  }, []);

  useEffect(() => {
    if (meta) {
      if ("locations" in meta) {
        let temp = [];
        meta.locations?.map((x, ind) => {
          temp.push({
            label: `${x.code} - ${x.desc}`,
            value: x.id
          })
        });
        setOutlets(temp);
      }
    }
  }, [meta]);

  const onSearch = (search) => {
    if (search && 'outlets' in search) {
      let searching = {};
      searching = {
        date_from: search?.start_date ? dayjs(search?.start_date).format("YYYY-MM-DD") : "",
        date_to: search?.end_date ? dayjs(search?.end_date).format("YYYY-MM-DD") : "",
        is_non_sales: search?.non_sales?.value
      };
      if (search?.outlets?.length > 0) {
        let temp2 = [];
        search?.outlets?.map(x => {
          temp2.push(x.value)
        });
        searching["location_ids"] = JSON.stringify(temp2);
      }
      setSearchVal(searching);
      dispatch(getSalesHourly(searching, props.setLoading));
    } else {
      setSearchVal(null);
      dispatch(getSalesHourly(null, props.setLoading));
    }
  };

  const exportReport = async () => {
    if (orders?.total_count === 0) {
      return message.warning(t("General.no_data_export"));
    }
    props.setLoading(true);

    await exportSalesReport(searchVal, "sales_hourly_listing").then((res) => {
      props.setLoading(false);
      if (res.data) {
        const aElement = document.createElement('a');
        let filename = res.headers["x-filename"];
        aElement.setAttribute('download', filename ?? "sample.pdf");
        const href = URL.createObjectURL(res.data);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("General.hourly_sales_report")} btnList={allowed([AllRoles.REPORTING.SALES_PAYMENT], 'write') ? btnList : null} />
        </Col>
        <Col span={24} className="">
          <Card bordered={false}>
            <Search onSearch={onSearch} field1={outlets} />

            <div className="table-responsive" style={{ overflowX: 'auto', marginTop: "30px" }}>
              <table className='table table-borderless w-100' style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th className=''>{t("General.business_date")}</th>
                    <th className=''>{t("SalesReporting.order_close_time")}</th>
                    <th className=''>{t("Outlet.outlet")}</th>
                    <th className='text-right'>{t("Inventory.gross_amt")}</th>
                    <th className='text-right'>{t("Delete.discount")}</th>
                    <th className='text-right'>{t("Crm.net_sales")}</th>
                    <th className='text-right'>{t("General.tax")}</th>
                    <th className='text-right'>{t("Dashboard.charges")}</th>
                    <th className='text-right'>{t("SalesReporting.adj_amt")}</th>
                    <th className='text-right'>{t("SalesReporting.tender_amt")}</th>
                    <th className='text-right'>{t("Inventory.inv_dot_cost")}</th>
                    <th className='text-right'>{t("Product.item_qty")}</th>
                    <th className='text-right'>{t("SalesReporting.trans_count")}</th>
                    <th className='text-right'>{t("SalesReporting.guest_count")}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    orders?.list?.length <= 0 &&
                    <tr>
                      <td colSpan="11">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </td>
                    </tr>
                  }
                  {
                    orders?.list?.length > 0 &&
                    orders?.list?.map((x, ind) => {
                      return (
                        <Fragment key={ind}>
                          {
                            x.list?.map((y, yIndex) => {
                              return (
                                <tr key={yIndex}>
                                  <td>{y.date}</td>
                                  <td>{y.time}</td>
                                  <td>{y.location_code}</td>
                                  <td align="right">{comma(y.gross_amount.toFixed(2))}</td>
                                  <td align="right">{comma(y.discount_amount.toFixed(2))}</td>
                                  <td align="right">{comma(y.net_sales.toFixed(2))}</td>
                                  <td align="right">{comma(y.tax_amount.toFixed(2))}</td>
                                  <td align="right">{comma(y.delivery_charge.toFixed(2))}</td>
                                  <td align="right">{comma(y.adjustment_amount.toFixed(2))}</td>
                                  <td align="right">{comma(y.tender_amount.toFixed(2))}</td>
                                  <td align="right">{comma(y.inv_cost.toFixed(2))}</td>
                                  <td align="right">{comma(y.quantity)}</td>
                                  <td align="right">{comma(y.trans_count)}</td>
                                  <td align="right">{comma(y.guest_count)}</td>
                                </tr>
                              )
                            })
                          }
                          <tr className='bg-gray text-white fwbold'>
                            <td align='' colSpan="3">{t("Crm.subtotal")}</td>
                            {
                              x?.sub_totals && Object.entries(x?.sub_totals)?.map(([key, data], zIndex) => {
                                return (
                                  <td key={zIndex} align='right'>{comma(data)}</td>
                                )
                              })
                            }
                          </tr>
                        </Fragment>
                      )
                    })
                  }
                  <tr className='bg-gray fwbold text-white'>
                    {
                      orders?.list?.length <= 0
                        ? <td colSpan="13">{t("SalesReporting.grand_total")}</td>
                        : <td align='' colSpan="3">{t("SalesReporting.grand_total")}</td>
                    }
                    {
                      orders?.grand_totals && Object.entries(orders?.grand_totals)?.map(([key, data], index) => {
                        return (
                          <td key={index} align='right'>
                            {comma(data)}
                          </td>
                        )
                      })
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  )
}